import React from 'react';
import { motion } from 'framer-motion';
import { AGREEXA_APP_URL } from '../lib/links';
import { Heart, MessageCircle, Eye, Download, Bookmark, Clock, Wrench } from 'lucide-react';
const projects = [{
  id: 1,
  title: 'Modern Walnut Desk with Hidden Cable Management',
  image: 'https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?q=80&w=800&auto=format&fit=crop',
  author: 'Sarah Woodcraft',
  difficulty: 'Hard',
  time: '2 Weeks',
  likes: '2.4k',
  views: '15k',
  height: 'h-96'
}, {
  id: 2,
  title: 'AI-Powered Plant Monitor (ESP32)',
  image: 'https://images.unsplash.com/photo-1592486058622-c31b51e064e0?q=80&w=800&auto=format&fit=crop',
  author: 'TechMaker',
  difficulty: 'Medium',
  time: '4 Hours',
  likes: '856',
  views: '5.2k',
  height: 'h-64'
}, {
  id: 3,
  title: 'Off-Grid Solar Generator Build',
  image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?q=80&w=800&auto=format&fit=crop',
  author: 'EcoBuilder',
  difficulty: 'Hard',
  time: '1 Week',
  likes: '4.1k',
  views: '22k',
  height: 'h-80'
}, {
  id: 4,
  title: '3D Printed Mechanical Keyboard Case',
  image: 'https://images.unsplash.com/photo-1595225476474-87563907a212?q=80&w=800&auto=format&fit=crop',
  author: 'PrintMaster',
  difficulty: 'Easy',
  time: '12 Hours',
  likes: '1.2k',
  views: '8k',
  height: 'h-72'
}, {
  id: 5,
  title: 'Automated Greenhouse with Arduino',
  image: 'https://images.unsplash.com/photo-1585320806297-9794b3e4ce88?q=80&w=800&auto=format&fit=crop',
  author: 'GreenThumb',
  difficulty: 'Medium',
  time: 'Weekend',
  likes: '3.3k',
  views: '18k',
  height: 'h-96'
}, {
  id: 6,
  title: 'Minimalist Plywood Chair',
  image: 'https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?q=80&w=800&auto=format&fit=crop',
  author: 'DesignDIY',
  difficulty: 'Medium',
  time: '2 Days',
  likes: '1.8k',
  views: '11k',
  height: 'h-64'
}];
export function ProjectsMasonry() {
  const goToAgreexa = () => {
    window.location.href = AGREEXA_APP_URL;
  };
  return <section className="py-24 bg-soft dark:bg-navy-900" data-id="element-276">
      <div className="max-w-7xl mx-auto px-6" data-id="element-277">
        <div className="flex flex-col md:flex-row items-end justify-between mb-12 gap-6" data-id="element-278">
          <div data-id="element-279">
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 dark:text-white mb-4" data-id="element-280">
              Trending Projects
            </h2>
            <p className="text-lg text-navy-700 dark:text-gray-400 max-w-2xl" data-id="element-281">
              Discover what the community is building right now.
            </p>
          </div>
          <div className="flex gap-4" data-id="element-282">
            <button onClick={goToAgreexa} className="px-4 py-2 rounded-full glass text-navy-900 dark:text-white font-medium hover:bg-white/50 dark:hover:bg-white/10 transition-colors" data-id="element-283">
              Latest
            </button>
            <button onClick={goToAgreexa} className="px-4 py-2 rounded-full bg-navy-900 dark:bg-white text-white dark:text-navy-900 font-medium" data-id="element-284">
              Popular
            </button>
          </div>
        </div>

        {/* Masonry Grid Simulation using CSS Columns */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-285">
          {projects.map((project, index) => <motion.div key={project.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} onClick={goToAgreexa} className="break-inside-avoid group relative rounded-2xl overflow-hidden bg-white dark:bg-navy-800 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer" data-id="element-286">
              {/* Image Container */}
              <div className={`relative w-full ${project.height} overflow-hidden`} data-id="element-287">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-288" />

                {/* Overlay Actions */}
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-between p-4" data-id="element-289">
                  <div className="flex justify-end gap-2" data-id="element-290">
                    <button className="p-2 rounded-full bg-white/20 backdrop-blur-md text-white hover:bg-white/40 transition-colors" data-id="element-291">
                      <Bookmark size={18} data-id="element-292" />
                    </button>
                    <button className="p-2 rounded-full bg-white/20 backdrop-blur-md text-white hover:bg-white/40 transition-colors" data-id="element-293">
                      <Download size={18} data-id="element-294" />
                    </button>
                  </div>
                  <div className="flex gap-2" data-id="element-295">
                    <span className="px-3 py-1 rounded-full bg-black/50 backdrop-blur-md text-white text-xs font-medium flex items-center gap-1" data-id="element-296">
                      <Clock size={12} data-id="element-297" /> {project.time}
                    </span>
                    <span className="px-3 py-1 rounded-full bg-black/50 backdrop-blur-md text-white text-xs font-medium flex items-center gap-1" data-id="element-298">
                      <Wrench size={12} data-id="element-299" /> {project.difficulty}
                    </span>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-5" data-id="element-300">
                <h3 className="text-lg font-bold text-navy-900 dark:text-white mb-2 line-clamp-2 group-hover:text-orange-500 transition-colors" data-id="element-301">
                  {project.title}
                </h3>
                <div className="flex items-center justify-between mt-4" data-id="element-302">
                  <div className="flex items-center gap-2" data-id="element-303">
                    <div className="w-6 h-6 rounded-full bg-gradient-to-br from-orange-400 to-orange-600" data-id="element-304" />
                    <span className="text-sm text-gray-600 dark:text-gray-400 font-medium" data-id="element-305">
                      {project.author}
                    </span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-500 dark:text-gray-400 text-sm" data-id="element-306">
                    <span className="flex items-center gap-1" data-id="element-307">
                      <Eye size={14} data-id="element-308" /> {project.views}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-309">
                      <Heart size={14} data-id="element-310" /> {project.likes}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-311">
          <button onClick={goToAgreexa} className="px-8 py-3 rounded-full border-2 border-navy-200 dark:border-navy-700 text-navy-900 dark:text-white font-semibold hover:border-orange-500 hover:text-orange-500 dark:hover:border-orange-500 dark:hover:text-orange-400 transition-colors" data-id="element-312">
            Load More Projects
          </button>
        </div>
      </div>
    </section>;
}